import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t,
    language
  } = useLanguage();
  const isHebrew = language === 'he';
  return <footer className="text-white/80 py-8 mt-12 md:mt-20 bg-[#1B2A4A]" data-id="element-16" data-mp="32nulgo2wc31d">
      <div className="max-w-7xl mx-auto px-6 text-center" data-id="element-17" data-mp="32pp5m06cfr4e">
        <p className="text-sm mb-2" data-id="element-18" data-mp="36oo5359b2vog">{t.footer.copyright}</p>
        <p className="text-xs text-white/50" data-id="element-19" data-mp="36n3grxdl48z1">
          {isHebrew ? 'למידע על נגישות, אנא צרו איתנו קשר.' : 'For accessibility information, please contact us.'}
        </p>
      </div>
    </footer>;
}